import { Typography } from "@mui/material";

export const BasicTextAtom = (props: any) => {
  return (
    <Typography variant="h6" style={{ fontSize: "16px" }}>
      {props.children}
    </Typography>
  );
};
